import { LEAGUE } from "../models/NBA";
import { PlaylistVideo, VideoEvent } from "../client";

/**
 * - gameId starting with "10" is WNBA (e.g. 1022400001)
 * - gameId starting with "00" is NBA (e.g. 0022300001)
 * - Team IDs starting with "1611" are WNBA franchises (e.g. 1611661321 Dallas Wings)
 * - Team IDs starting with "1610" are NBA franchises (e.g. 1610612737 Atlanta Hawks)
 */
export const getVideoLeague = (video: VideoEvent | PlaylistVideo): LEAGUE => {
  if (video.gameId) {
    const cleanGameId = String(video.gameId).trim();
    if (cleanGameId.startsWith("10")) return LEAGUE.WNBA;
    if (cleanGameId.startsWith("00")) return LEAGUE.NBA;
  }

  const teamId = video.playerTeamId || video.hTeamId || video.vTeamId;
  if (teamId) {
    const cleanTeamId = String(teamId).trim();
    if (cleanTeamId.startsWith("1611")) return LEAGUE.WNBA;
    if (cleanTeamId.startsWith("1610")) return LEAGUE.NBA;
  }

  return LEAGUE.NBA;
};

/**
 * - Active on: Home ("/"), Search ("/search"), and direct video player ("/video/*").
 */
export const isLeagueSwitcherVisible = (pathname: string): boolean => {
  return pathname === "/" || pathname === "/search" || pathname.startsWith("/video");
};

/**
 * Safely parse a league string (case-insensitive) into the LEAGUE enum.
 */
export const parseLeague = (val?: string | null): LEAGUE => {
  const lower = val?.trim().toLowerCase();
  return lower === "wnba" ? LEAGUE.WNBA : LEAGUE.NBA;
};

